<template>
  <div>
    <div v-if="!isRead" class="navigation-tabs">
      <b-overlay :show="isBtnLoading" class="d-inline-block" rounded opacity="0.6" spinner-small spinner-variant="primary">
        <b-button @click="CountPayslipAttendace()" class="d-flex" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary">Hitung</b-button>
      </b-overlay>
    </div>
    <div class="tables">
      <b-form-group>
        <b-form-input v-model="filter.employeeName" style="width: 247px;" v-on:keyup.enter="GetOvertime()" placeholder="Cari Nama Karyawan..."></b-form-input>
      </b-form-group>
      <BaseTable
        :fields="fields"
        :items="items"
        :loading="loading"
        :rows="pagination.total"
        :perPage="filter.size"
        :currentPage="filter.page"
        :handle-page-change="handlePageChange"
        :hideView="true"
        :hideUpdate="true"
        :hideDelete="true"
        :HideOptions="true"
      />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import BaseTable from "@/components/BaseTable.vue";
import { BCard, BRow, BCol, BButton, BFormInput,BOverlay,BFormGroup } from "bootstrap-vue";
import { AttendaceTabsServices } from '../../services/attendance.service';
import { successNotification, errorNotification } from "@/auth/utils";
export default {
  name: "Overtime",
  components: {
    BCard,
    BRow,
    BButton,
    BaseTable,
    BOverlay,
    BFormGroup,
    BFormInput
  },
  directives: {
    Ripple,
  },
  props: {
    isRead: {
      type: Boolean
    }
  },
  data() {
    return {
      fields: [
        {
          key: "no",
          label: "No"
        },
        {
          key: "employeeName",
          label: "Nama"
        },
        {
          key: "weekdayOvertime",
          label: "Hari Kerja Lembur"
        },
        {
          key: "weekendOvertime",
          label: "Hari Libur Lembur"
        },
        {
          key: "hourWeekdayOvertime",
          label: "Jam Normal"
        },
        {
          key: "hourWeekendOvertime",
          label: "Jam Hari Libur"
        },
        {
          key: "coefOvertime",
          label: "Koef Lembur"
        },
        {
          key: "salaryMultiplier",
          label: "Pengali Gaji"
        }
      ],
      items: [],
      isBtnLoading: false,
      loading: false,
      pagination: {
        total: 0
      },
      filter: {
        employeeName: "",
        page: 1,
        size: 10
      },
    }
  },
  watch: {
    'filter.page': function () {
      this.GetOvertime();
    }
  },
  methods: {
    handlePageChange(value) {
      this.loading = true
      this.filter.page = value;
    },
    async GetOvertime() {
      this.loading = true;
      let router = this.$route;
      let req = {
        page: this.filter.page,
        size: this.filter.size,
        payslipId: router.params.id,
        employeeName: this.filter.employeeName
      };
      window.console.log(req);
      this.items = [];
      await AttendaceTabsServices.find(req)
        .then((result) => {
          window.console.log(result);
          if (result.code === "00") {
            result.data.content.forEach((items,index) => {
              items['no'] = index;
              if (result.data.content.length >= 1) {
                Object.keys(result.data.content[0]).forEach((key) => {
                  if (items[key] === null) {
                    items[key] = '-';
                  }
                });
              }
              this.items.push(items);
            });
            this.pagination.total = result.data.total;
          }
          this.loading  =  false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", e.message);
        });
    },
    CountPayslipAttendace() {
      this.isBtnLoading = true;
      let router = this.$route;
      let req = {
        payslipId: router.params.id
      };
      this.$http.post('/payslip/payslip-attendance/calculate-overtime', req)
        .then((result) => {
          window.console.log(result);
          if (result.data.code === "00") {
            successNotification(this,result.data.message);
            this.GetOvertime();
          } else {
            errorNotification(this,"Oops!",result.message);
          }
          this.isBtnLoading  =  false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", e.message);
          this.isBtnLoading  =  false;
        });
    }
  },
  mounted() {
    this.GetOvertime();
  }
}
</script>
